import config from 'config';
import { ListPayload, ListResponse } from 'core/http/response';
import axiosClient from '../../config/axios';
import { Country } from './country';

export const getCountries = (): Promise<ListPayload<Country>> =>
    axiosClient.get<ListResponse<Country>>(`${config.cmsUrl}/country`).then((response) => response.data.payload);
